import { render, staticRenderFns } from "./personTable.vue?vue&type=template&id=4c260d1c&scoped=true&"
import script from "./personTable.vue?vue&type=script&lang=js&"
export * from "./personTable.vue?vue&type=script&lang=js&"
import style0 from "./personTable.vue?vue&type=style&index=0&id=4c260d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c260d1c",
  null
  
)

export default component.exports